export default {
  // FHRS (en)
  FHRS_0: 'fhrs_0_en-gb',
  FHRS_1: 'fhrs_1_en-gb',
  FHRS_2: 'fhrs_2_en-gb',
  FHRS_3: 'fhrs_3_en-gb',
  FHRS_4: 'fhrs_4_en-gb',
  FHRS_5: 'fhrs_5_en-gb',
  FHRS_AWAITING_INSPECTION: 'fhrs_awaitinginspection_en-gb',
  FHRS_EXEMPT: 'fhrs_exempt_en-gb',

  // FHRS (cy)
  FHRS_CY_0: 'fhrs_0_cy-gb',
  FHRS_CY_1: 'fhrs_1_cy-gb',
  FHRS_CY_2: 'fhrs_2_cy-gb',
  FHRS_CY_3: 'fhrs_3_cy-gb',
  FHRS_CY_4: 'fhrs_4_cy-gb',
  FHRS_CY_5: 'fhrs_5_cy-gb',
  FHRS_CY_AWAITING_INSPECTION: 'fhrs_awaitinginspection_cy-gb',
  FHRS_CY_RATING_AWAITED: 'fhrs_ratingawaited_cy-gb',
  FHRS_CY_EXEMPT: 'fhrs_exempt_cy-gb',

  // FHIS (Scotland)
  FHIS_PASS: 'fhis_pass_en-gb',
  FHIS_PASS_EAT_SAFE: 'fhis_pass_and_eat_safe_en-gb',
  FHIS_IMPROVEMENT_REQUIRED: 'fhis_improvement_required_en-gb',
  FHIS_AWAITING_INSPECTION: 'fhis_awaiting_inspection_en-gb',
  FHIS_EXEMPT: 'fhis_exempt_en-gb',
};
